var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDelete = function SvgIconDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_delete_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.249 15.021a.75.75 0 0 1-.748-.72l-.25-6.5a.75.75 0 0 1 .72-.779H8c.4 0 .733.317.748.72l.25 6.5a.75.75 0 0 1-.72.778c-.01.002-.02.002-.03.002ZM11.751 15.021h-.03a.75.75 0 0 1-.72-.779l.25-6.5a.749.749 0 0 1 .748-.72h.03a.75.75 0 0 1 .72.779l-.25 6.5a.749.749 0 0 1-.748.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4h-3.5v-.75C13.5 2.01 12.49 1 11.25 1h-2.5C7.51 1 6.5 2.01 6.5 3.25V4H3a.75.75 0 0 0 0 1.5h.52l.422 10.342A2.243 2.243 0 0 0 6.19 18h7.62c1.211 0 2.2-.948 2.248-2.158L16.48 5.5H17A.75.75 0 0 0 17 4Zm-9-.75c0-.413.337-.75.75-.75h2.5c.413 0 .75.337.75.75V4H8v-.75Zm6.56 12.531a.748.748 0 0 1-.75.719H6.19a.748.748 0 0 1-.75-.719L5.02 5.5h9.96l-.42 10.281Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_delete_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))));
};
export default SvgIconDelete;